import type { Components, Theme } from '@mui/material';

export const MuiOutlinedInput: Components<Theme>['MuiOutlinedInput'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.neutral.darker,
      },
    }),
  },
};
